export const facebookAccountStatus = {
  CONNECTED: "connected",
  NOT_AUTHORIZED: "not_authorized",
  UNKNWON: "unknown"
};
